import * as backend from '@/api/backend';
import { checkResponseStatus } from '@/util/check';

const defaultHobby = {
  hobbyID: null,
  color: '#ffffff',
  backgroundColor: '#a5988d',
  text: '',
  timestamp: '',
};

export default {
  state: {
    hobbys: [],
    loading: false,
    error: false,
    hobbyEdit: {
      ...defaultHobby,
    },
    defaultHobby,
  },
  mutations: {
    fetch(state) {
      state.loading = true;
    },
    errorHobbys(state) {
      state.hobbys = [];
      state.loading = false;
      state.error = true;
    },
    setHobbys(state, hobbys) {
      state.hobbys = hobbys;
      state.loading = false;
      state.error = false;
    },
    editHobby(state, hobby) {
      const formattedHobby = {
        ...hobby,
      };

      Object.keys(state.hobbyEdit).forEach((key) => {
        state.hobbyEdit[key] = formattedHobby[key];
      });
    },
    updateHobby(state, hobby) {
      Object.keys(hobby).forEach((key) => {
        state.hobbyEdit[key] = hobby[key];
      });
    },
  },
  actions: {
    async fetchHobbys({ commit }) {
      commit('fetch');
      try {
        const response = await backend.getHobbys();
        await checkResponseStatus(200, response);

        const json = response.data;
        const formattedJson = json.map((hobby) => ({
          ...hobby,
        }));
        commit('setHobbys', formattedJson);
      } catch (e) {
        console.error(e);
        commit('errorHobbys');
      }
    },
  },
  namespaced: true,
};
